import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VTooltip,
    {
      attrs: { top: "", "max-width": "300" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "div",
                _vm._g(
                  _vm._b(
                    { staticClass: "icon-container" },
                    "div",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _vm.approved === true
                    ? _c(
                        VIcon,
                        { attrs: { size: "24", color: _vm.success } },
                        [_vm._v("\n        mdi-check-circle\n      ")]
                      )
                    : _vm.approved === false
                    ? _c(VIcon, { attrs: { size: "24", color: "red" } }, [
                        _vm._v("\n        mdi-close-circle\n      "),
                      ])
                    : _vm.unitLevelAndNull
                    ? _c(
                        VIcon,
                        { attrs: { size: "24", color: _vm.nullIconColour } },
                        [_vm._v("\n        mdi-circle\n      ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.tooltipMessage))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }